import getApi from '@/lib/axios';
import { Card } from 'primereact/card';
import { CardModel } from '@/features/crm/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

async function updateCard(id: number, card: CardModel) {
  const api = await getApi();

  return api.patch<Card>(`/crm/cartoes/${id}/`, card);
}

export { updateCard };
